import ApiManager from '@/utils/ApiManager'
import Constants from '@/utils/Constants'
import Utility from '@/utils/Utility'
import Vue from 'vue'

const state = {
	active: false,

  // model
  screenModel: [],

  //form
  serviceId: null,
  buttonId: null,
  index: 0,

  // 選択されたファイル情報
  value: null,

  // モーダルに重ねて表示する場合true
  overlay: false,
}

const getters = {
	get: state => state,

  // contentsScreenUuidから画面名を取得
  getScreenName: state => screenCode => {
    try {
      console.log('screenModel', state.screenModel)
      return state.screenModel.filter(item => item.screenCode === screenCode)[0].screenName
    // eslint-disable-next-line
    } catch (e) {
      return ''
    }
  }
}

const actions = {
	show ({commit}, {serviceId, buttonId, index, overlay}) {
		// cover
		this.dispatch('core/showModalCover')
		
    commit('setServiceId', serviceId)
    commit('setButtonId', buttonId)
    if (index !== undefined) commit('setIndex', index)

    if (overlay === undefined) {
      commit('setOverlay', false)
    } else {
      commit('setOverlay', overlay)
    }

		commit('showed')
	},
	hide ({commit}) {
		if (!state.active) return
		commit('hided')
		
    if (state.overlay) return

		// cover
		setTimeout(() => {
			this.dispatch('core/hideModalCover')
		}, 350)
	},

  /**
   * 初期データを読出し
   */
  loadModel ({commit}, {serviceContentsParams}) {
    const screenIdMstParams = {}

    return new Promise((resolve, reject) => {
      ApiManager.request(
        [
          'serviceContentsSetting',
          'screenIdMst',
        ],
        [
          'v1ServiceContentsSettingRelationalDetailGet',
          'v1ScreenIdMstListGet',
        ],
        [
          serviceContentsParams,
          screenIdMstParams,
        ])
        .then(res => {
          let status = Utility.parseResponse(res)

          if (status.result) {
            commit('setScreenModel', res)
            // commit('setScreenModel', res[0].data.serviceContentsSettings)
            console.log('screenModel', state.screenModel)
            resolve()

          } else if (status.error) {
            // エラーメッセージ表示
            reject(res)
          } else {
            // アプリケーションエラー表示
            reject(null)
          }
        })
        .catch(error => {
          // アプリケーションエラー表示
          reject(null)
        })
    })
  },

  /**
   * 選択されたファイル情報を保持
   */
  setValue ({commit}, data) {
    commit('setValue', data)
  },

  /**
   * リセット
   */
  reset ({commit}) {
    commit('reset')
  }
}

const mutations = {
	showed (state) {
		state.active = true
	},
	hided (state) {
    state.active = false
	},

  // model
  setScreenModel (state, data) {
    // 指定サービスのコンテンツに属する画面から、ホーム画面設定されている画面を取得
    let list = []
    data[0].data.serviceContentsSettings.forEach(content => {
      content.contentsScreenSettings
        .filter(item => item.isHomeScreen === 1)
        .forEach(screen => {
          list.push({
            contentsScreenId: screen.contentsScreenId,
            contentsScreenUuid: screen.contentsScreenUuid,
            screenCode: screen.screenSettings.screenNameSetting.screenCode,
            // screenCode: screen.contentsScreenUuid,
            screenName: content.contentsName + ' : ' + (screen.screenName || '未設定'),
            isReleased: screen.isReleased
          })
        })
    })

    // 「画面遷移対応：あり」の固定画面を追加
    data[1].data.screenIdMsts.forEach(item => {
      if (item.screenTransitionFlg) {
        list.push({
          contentsScreenId: item.screenId,
          contentsScreenUuid: item.screenIdMstUuid,
          screenCode: item.screenId,
          isReleased: item.screenIdStatus,
          screenName: item.screenName
        })
      }
    })

    Vue.set(state, 'screenModel', list)
  },
  
  // form
  setServiceId (state, id) {
    state.serviceId = id
  },
  setButtonId (state, id) {
    state.buttonId = id
  },
  setIndex (state, index) {
    state.index = index
  },
  setValue (state, data) {
    Vue.set(state, 'value', data)
  },

  // overlay
  setOverlay (state, flag) {
    state.overlay = flag
    console.log('actions', flag)
  },

  // reset
  reset (state) {
    Vue.set(state, 'screenModel', [])
    Vue.set(state, 'value', null)
    // state.overlay = false
  }
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}
